/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import React from 'react';
import {createRoot}from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import CacheBuster from 'react-cache-buster';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import appversion from '../package.json';

const appVersion = appversion.version;

// Get the current host and pathname
let host = window.location.host.toLowerCase();
const pathname = window.location.pathname.toLowerCase();

// Redirect logic for tpo-pr
if (pathname === "/tpo-pr" || pathname === "/tpo-pr/") {
  // Redirect to /tpo-pr/es
  const redirectTo = `https://${host}/tpo-pr/es`;
  window.location.href = redirectTo;
}

// Render the React application
const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CacheBuster
      currentVersion={appVersion}
      isEnabled={true} // If false, the library is disabled.
      isVerboseMode={false} // If true, the library writes verbose logs to console.
      metaFileDirectory={process.env.PUBLIC_URL}
    >
      <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
        <App />
      </BrowserRouter>
    </CacheBuster>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
